import React from 'react';
import { Field } from 'redux-form';
import _ from 'lodash';

const RadioOptions = ({ options, input, inputStyle }) => (
  <div style={{ display: 'grid', gridTemplateColumns: '1fr', paddingBottom: '30px', gap: '20px' }}>
    {options.map(({ label, value, disabled }) => (
      <div style={{ ...inputStyle }} className="input-label" key={value}>
        <label>
          <input
            {..._.omit(input, 'value')}
            type="radio"
            value={value}
            checked={input.value === value}
            disabled={disabled}
            className={`m-radio-input${disabled ? 'disabled' : ''}`}
          />
          <span style={disabled ? { paddingLeft: '8px' } : null} className={`m-radio-parts${disabled ? 'disabled' : ''}`}>
            {label}
          </span>
        </label>
      </div>
    ))}
  </div>
);
const CustomRadioField = props => {
  const { name, ...rest } = props;

  return <Field name={name} component={RadioOptions} {...rest} type={'text'} />;
};

export default CustomRadioField;
